<template>
  <div>
    <div class="mycontainer-main" v-if="isLoadingCategory">
      <div class="main-content list-item-menu">
        <div class="item-menu cols-4"
          style="height: 553px; padding: 50px 10px;"
          v-for="n in 8" :key="n" >
          <div class="imgLoadingTopHome flex1"></div>
        </div>
      </div>
    </div>
    <div v-else-if="selectedCategory && selectedCategory.uuid == $const.COUPON_UUID"
         class="mycontainer-main">
      <div class="container-coupon" v-if="$auth.check()">
        <div class="coupon-box">
          <div class="coupon-inner">
            <div class="input-box">
              <span>{{ $t('enter_coupon') }}</span>
              <input type="text"
                     v-model="couponCode"
                     :placeholder="$t('add_coupon_place_holder')"
                     class="form-control"/>
              <button class="btn btn--primary" @click="redeemCode">{{ $t('add_coupon_button') }}</button>

              <span v-if="couponMessage"
                    class="coupon-message">
                {{ couponMessage }}
              </span>
            </div>
          </div>
        </div>

        <div class="mycontainer-main"
             :class="{'mycontainer-main--coupon': selectedCategory && selectedCategory.uuid == $const.COUPON_UUID}">
          <div v-if="selectedCategory && selectedCategory.uuid == $const.COUPON_UUID">
            <div class="clearfix"></div>

            <div class="main-content list-item-menu">
              <item-coupon v-for="(item) in items"
                           :item="item"
                           :cols="2"
                           :key="genUniqueKey(item)"
                           :uuid="$route.params.uuid ? $route.params.uuid : $route.params.sub">
              </item-coupon>
            </div>
          </div>
        </div>
      </div>
      <div class="container-coupon" v-else>
        <div v-if="$session.get('showCouponBanner') == 1 && bannerCoupon"
          class="coupon-banner">
          <item-coupon
            :item="bannerCoupon"
          >
          </item-coupon>
        </div>
        <div v-else class="coupon-nologin">
          <span v-html="$t('coupon_not_login')"></span>
          <a v-on:click.stop="redirectToUrl('/login/?returnUrl=/order/coupons')" class="button button--primary">{{ $t('button_login') }}</a>
          <a v-on:click.stop="redirectToUrl('/register')" class="button button--primary register">{{ $t('coupon_register') }}</a>
        </div>
      </div>
    </div>

    <div v-if="selectedCategory && selectedCategory.uuid != $const.COUPON_UUID"
         class="mycontainer-main" v-bind:class="{'has-filter': !empty(attributeList)}">
      <div v-for="(item) in itemsFilter"
           :key="genUniqueKey(item)">
        <div class="clearfix"></div>

        <!--H&H-->
        <h2 v-if="item.single_type && item.single_type.hasOwnProperty('is_default') && !item.single_type.is_default"
            class="watermark desktop cond caps xs-my-20 xs-mx-10 xs-text-center heading-hr">
          <img v-if="item.single_type.image && item.single_type.image.banner"
               :src="item.single_type.image.banner"/>
          <span class="fs-30 pr-7" v-else>{{item.single_type.name}} </span>
        </h2>
        <div v-if="item.single_type && item.single_type.hasOwnProperty('is_default') && !item.single_type.is_default"
             class="watermark mobile cond caps xs-my-20 xs-mx-10 xs-text-center">
          <img v-if="item.single_type.image && item.single_type.image.banner"
               :src="item.single_type.image.banner"/>
          <p class="fs-30 pr-7 pb-0" v-else>{{item.single_type.name}} </p>
        </div>


        <div class="main-content list-item-menu">

          <item-combo v-for="(menu) in item.singles"
                      :item="menu"
                      :cols="menu.columnDisplay ? menu.columnDisplay : columnDisplay"
                      :key="genUniqueKey(menu)"
                      :strikethrough_combo="enable_combo_strikethrough_web"
                      v-if="menu.is_combo && isHideWithoutStore(menu)"></item-combo>
          <item-menu :item="menu"
                     :cols="menu.columnDisplay ? menu.columnDisplay : columnDisplay"
                     :key="genUniqueKey(menu)"
                     :isHalf="menu.isHalf"
                     :discount="menu.discount"
                     :strikethrough_single="enable_single_strikethrough_web"
                     :onlyLunch="menu.onlyLunch || null"
                     :uuid="$route.params.uuid ? $route.params.uuid : $route.params.sub"
                     v-else-if="!menu.is_combo && !menu.isHalf && isHideWithoutStore(menu)"></item-menu>
          <item-half-half
            v-else-if="!menu.is_combo && menu.isHalf && isHideWithoutStore(menu)"
            :item="menu"
            :cols="menu.columnDisplay ? menu.columnDisplay : columnDisplay"
            :key="genUniqueKey(menu)"
            :isHalf="menu.isHalf"
            :discount="menu.discount"
            :onlyLunch="menu.onlyLunch || null"
            :uuid="$route.params.uuid ? $route.params.uuid : $route.params.sub"
            ></item-half-half>
        </div>
      </div>
      <!-- <div class="gst xs-flex-center xs-justify-start pb-30" v-if="enable_combo_strikethrough_web">
        {{$t('gst')}}
      </div> -->
    </div>
  </div>
</template>
<script>
    import moment from 'moment'
    import {
      mapState,
      mapGetters,
      mapActions
    } from 'vuex'
    import * as types from '@/store/types'
    import constants from "../constants";
    import DispositionPopup from '../components/home/HomeLocalizationMapZipcodeNewDesign'
    const ModalNotify = () => import('../components/popup/ModalNotifyTakeAwayLess')

    export default {
      components: {
        ItemMenu: () => import('@/components/menu/Item.vue'),
        ItemCombo: () => import('@/components/menu/ItemCombo.vue'),
        ItemCoupon: () => import('@/components/coupon/Item.vue'),
        ItemHalfHalf: () => import('@/components/menu/ItemHalfHalf.vue')
      },
    destroyed() {
      this.$root.$off('onTrackingCategory')
      this.setAttributeList(null)
      this.setAttributeFilter1(null)
    },
      data() {
        return {
          items: [],
          itemsFilter: [],
          sizeCrust: [],
          extraCheese: [],
          categoryId: '',
          subCategoryId: '',
          hasHalf: false,
          slug: this.$route.params.slug,
          columnDisplay: 4,
          couponCode: '',
          couponMessage: '',
          countDownTime : null,
          enable_combo_strikethrough_web: '',
          enable_single_strikethrough_web: '',
          isLoadingCategory: true,
          bannerCoupon: null
        }
      },
      mounted() {
        let vm = this
        this.$disposition.init(this)
        this.items = []
        this.initData()
        this.getColumnDisplay()
        this.$root.$on('onTrackingCategory', () => {
          this.trackpage()
          this.eventTrackingProductLoad(this, this.items, false, true)
        })
        this.$root.$on('reloadDataCategory', () => {
          vm.initData()
        })
        if (this.isShowModalTakeAwayLess) {
          this.setShowModalTakeAwayLess(false)
          this.$modal.show(ModalNotify, {}, {
            class: 'modal-menu',
            transition: 'nice-modal-fade',
            overlayTransition: 'overlay-fade',
            clickToClose: true,
            name: 'modal-notify'
          })
        }
        if (this.$session.get('showCouponBanner')) {
          this.axios.apiBanners.getBannersByPosition('?code=coupon_banner', respone => {
          let data = respone.data.data.item
          if(data && data.coupon_banner && data.coupon_banner.length > 0) {
            this.bannerCoupon = data.coupon_banner[0]
          }
        })
        }
      },
      computed: {
        ...mapState({
          isShowModalTakeAwayLess: 'showModalTakeAwayLess',
          attributeFilter: 'attributeFilter',
          attributeList: 'attributeList'
        }),
        ...mapGetters({
          selectedCategory: 'selectedCategory',
          selectedSubCategory: 'selectedSubCategory',
          selectedProduct: 'selectedProduct',
          isLandOnHomepageFirst: types.GET_LAND_ON_HOMEPAGE,
          configTenant: types.GET_CONFIG_TENANT
        })
      },
      watch: {
        attributeFilter (newvalue) {
          this.filteredItems()
        },
        items (newvalue) {
          this.filteredItems()
        },
        selectedCategory: function (newValue, oldValue) {
          if (this.selectedCategory && this.selectedCategory.uuid) {
            this.$store.commit('setCategoryUuid', this.selectedCategory.uuid)

            if (!this.selectedCategory.lower_categories || this.selectedCategory.lower_categories.length <= 0) {
              this.$store.commit('setSubCategoryUuid', null)
              this.categoryId = this.selectedCategory.uuid;
              this.subCategoryId = null;

              this.getColumnDisplay()
              this.initData();
            }
          } else {
            this.$store.commit('setCategoryUuid', null)
            this.subCategoryId = null;
          }
        },
        selectedSubCategory: function (newValue, oldValue) {
          if (this.selectedSubCategory && this.selectedSubCategory.uuid) {
            this.$store.commit('setSubCategoryUuid', this.selectedSubCategory.uuid)
            this.categoryId = this.selectedCategory.uuid;
            this.subCategoryId = this.selectedSubCategory.uuid;

            this.getColumnDisplay()
            this.initData();
          } else {
            this.$store.commit('setSubCategoryUuid', null)
            this.subCategoryId = null;
          }
        },
        configTenant: function () {
          this.enable_combo_strikethrough_web = this.checkVariable(this.configTenant.enable_combo_strikethrough_web ? this.configTenant.enable_combo_strikethrough_web : false)
          this.enable_single_strikethrough_web = this.checkVariable(this.configTenant.enable_single_strikethrough_web ? this.configTenant.enable_single_strikethrough_web : false)
          this.filterCombo = this.configTenant.filter_combo ? this.configTenant.filter_combo === '1' : false
        }
      },
      methods: {
        ...mapActions({
          setShowModalTakeAwayLess: types.SET_SHOW_MODAL_TAKE_AWAY_LESS,
          setAttributeList: types.SET_ATTRIBUTES_LIST,
          setAttributeFilter1: types.SET_ATTRIBUTES_FILTER
        }),
        filteredItems () {
          var vm = this
          if (this.empty(this.attributeFilter) || this.empty(this.items)) {
            this.itemsFilter = this._.cloneDeep(this.items)
            return true
          }
          let itemsAfterFilter = []
          for (let i in this.items) {
            let _item = this._.cloneDeep(this.items[i])
            if (_item.singles) {
              let _items = _item.singles.filter(item => {
                if (!item.attributes) {
                  return false
                }
                let flag = false
                for (let i of item.attributes) {
                  if (vm.attributeFilter.indexOf(i) > -1) {
                    flag = true
                    break
                  }
                }
                return flag
              })
              _item.singles = _items
              if (_item.singles.length > 0) {
                itemsAfterFilter.push(_item)
              }
            }
          }
          this.itemsFilter = itemsAfterFilter
        },
        checkVariable (variable) {
          return variable === '1' || variable === 1 || variable === true || variable === 'true'
        },
        isHideWithoutStore(item) {
          let disposition = this.$session.get('disposition')

          // if DO NOT HAVE Store & key `hide_without_store` === true, DO NOT SHOW
          if (typeof disposition === 'undefined'
            && item.customize
            && item.customize.hasOwnProperty('hide_without_store')
            && item.customize.hide_without_store === true
          ) {
            return false
          } else {
            return true
          }
        },
        trackpage() {
          let category = {}
          let subcategory = {}
          let categories = this.$session.get('listCategory')
          if (categories && categories.length > 0) {
            for (let i in categories) {
              if (categories[i].uuid == this.selectedCategory.uuid) {
                category = categories[i]
                if (category.hasOwnProperty('lower_categories')) {
                  for (let s in category.lower_categories) {
                    if (this.subCategoryId == category.lower_categories[s].uuid) {
                      subcategory = category.lower_categories[s]
                      break
                    }
                  }
                  if (this.empty(subcategory) && category.hasOwnProperty('lower_categories') && category.lower_categories.length > 0) {
                    subcategory = category.lower_categories[0]
                  }
                }
                break
              }
            }
          }
          let name = category.slug
          if (!this.empty(subcategory)) {
            name += '.' + subcategory.slug
          }
          let _type = 'product-list'
          if (this.selectedCategory.uuid == this.$const.COUPON_UUID) {
            name = 'account.coupon'
            _type = 'account'
          } else {
            name = 'product-list.' + name
          }
          this.eventTrackingScreenLoad(this, {screen: {'name': name, 'type': _type}})
        },
        getColumnDisplay() {
          if (this.selectedSubCategory && this.selectedSubCategory.uuid) {
            this.columnDisplay = this.selectedSubCategory.display_type.web
          } else if (this.selectedCategory && this.selectedCategory.uuid) {
            this.columnDisplay = this.selectedCategory.display_type ? this.selectedCategory.display_type.web : 4
          }
        },
        initData() {
          this.isLoadingCategory = true
          let vm = this
          let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''), this.$disposition.getByKey(this, 'collectionTimeValue', ''))
          if (!orderTime) {
            orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          }

          orderTime = this.convertSecond(orderTime)

          if (this.selectedCategory && this.selectedCategory.uuid) {
            if (this.$const.NON_LOCALIZATION_CATEGORY.indexOf(this.selectedCategory.slug) >= 0 && !this.checkPosition(this)) {
              this.redirectToPage(this.$const.SLUG_LIST.PIZZA)
              return false
            }
            this.trackpage()
            vm.items = []

            // Get categories from session
            let categories = vm.$session.get('listCategory')

            let currentCat = categories.find((el) => {
              return el.slug == vm.$route.params.slug
            })

            let orderType = vm.$disposition.getByKey(vm, 'orderType', '')

            vm.setAttributeList([])
            vm.setAttributeFilter1([])
            if (this.selectedCategory.uuid == this.$const.COUPON_UUID) {
              if (this.$auth.check()) {
                let params = {}
                params['page'] = 1
                params['limit'] = 500
                params['active'] = 1
                params['current_date'] = this.getCurrentDateLocal()

                this.axios.getCouponList(params, function (response) {
                  vm.items = response.data.data.items
                  vm.isLoadingCategory = false
                }, function (err) {
                  vm.isLoadingCategory = false
                })
              } else {
                vm.isLoadingCategory = false
                return
              }
            } else {
              let subCategoryId = this.selectedSubCategory ? this.selectedSubCategory.uuid : null
              let categoryId = this.selectedCategory ? this.selectedCategory.uuid : null
              let hasHalfHalf = true
              let currentOutletCode = parseInt(vm.getOutletCode(vm))

              if (vm._.includes(vm.$const.HALF_HALF_EXCLUDE_STORE, currentOutletCode)) {
                hasHalfHalf = false
              }

              let data = vm.getMenuRequest(categoryId, subCategoryId)
              data.single_type = 1
              data.outlet_code = vm.getOutletCode(this)

              vm.axios.getMenuByCategory(data, function (response) {
                let items = response.data.data.items;
                let category = vm.selectedSubCategory ? vm.selectedSubCategory : vm.selectedCategory
                let _displayColumn = 2
                let _hasSpecialOffer = false
                let isShowHalfHalf = false
                let discount = category.discount == 1

                if (category.piece == 2 || category.only_lunch > 0 || discount || currentCat.discount_30_pickup == 1) {
                  isShowHalfHalf = true
                }

                // Get SPECIAL OFFER item
                let arrSpecialItem = []
                let specialItem = {}
                for (let i = 0; i < items.length; i++) {
                  let singles = items[i].singles

                  for (let j = singles.length; j--;) {
                    let item = singles[j]
                    if (vm._.includes(vm.$const.SPECIAL_OFFER, item.uuid)) {
                      specialItem = {...item}
                      specialItem.columnDisplay = 2
                      _hasSpecialOffer = true

                      arrSpecialItem.push(specialItem)
                      // Remove duplicate Special item in list
                      singles.splice(j, 1);
                    }
                  }
                }
                if (hasHalfHalf && isShowHalfHalf) {
                  let halfItem = {
                    single_type: {
                      image: {
                        banner: !vm.isComboPage() ? vm.$const.HALF_HALF_IMAGES.CATEGORY : ''
                      },
                      is_default: false
                    },
                    singles: []
                  }

                  if (_hasSpecialOffer) {
                    halfItem.single_type.image.banner = ''
                  }
                  items.unshift(halfItem);
                }

                if (!items || !items.length) {
                  items = []
                  items.push({
                    singles: []
                  });
                }

                //PIZZA IS SELECTED (HALF & HALF)
                if (hasHalfHalf && isShowHalfHalf) {
                  /**
                   * 1. H&H: LUNCH
                   *    type == 1
                   *    HIDE H&H LUNCH WHEN NON-LOCALIZATION OR OUTLETCODE = DEFAULT_OUTLET
                    */
                  let outletCode = vm.getOutletCode(vm)
                  if (category.only_lunch > 0 && outletCode != vm.$const.DEFAULT_OUTLET) {
                    let half = getHalf(vm, 1, _displayColumn, currentCat);
                    if (half != '') items[0].singles.unshift(half);
                  }

                  /**
                   * 2. H&H: NORMAL H&H
                   *    type == 0
                    */
                  if (category.piece == 2) {
                    let half = getHalf(vm, 0, _displayColumn, currentCat);
                    if (half != '') items[0].singles.unshift(half);
                  }

                  // 3. H&H: DISCOUNT H&H
                  if (category.discount == 1) {
                    let half = getHalfDiscount(vm, _displayColumn, currentCat)
                    if (half != '') items[0].singles.unshift(half)
                  }

                  /**
                   * 4. H&H: PICKUP 30
                   *    type == 2
                   */
                  if (category.discount_30_pickup && orderType == vm.$const.CARRYOUT) {
                    let half = getPick30Half(vm, _displayColumn, currentCat);
                    if (half != '') items[0].singles.unshift(half);
                  }
                }
                // SPECIAL ITEMS
                if (_hasSpecialOffer) {
                  for (const item of arrSpecialItem) {
                    items[0].singles.unshift(item)
                  }
                }
                vm.items = items;
                // resort menus
                let _item = response.data.data.info
                let _attrs = []
                if (_item.attributes && _item.attributes.length > 0) {
                  _attrs = _item.attributes
                }
                vm.setAttributeList(_attrs)
                vm.items = vm.reSortMenu(items)

                // Add data for cart item
                vm.$cart.tier = data.tier
                vm.$cart.order_type = data.order_type
                vm.$cart.category_id = data.category_id
                // Add data for cart item
                vm.eventTrackingProductLoad(vm, vm.items, false, true)
                if(!vm.checkPosition(vm) && !vm.isLandOnHomepageFirst) {
                  const modalDWL = document.getElementsByClassName('modal-localization')
                  if (modalDWL && modalDWL.length > 0) {
                    return false
                  } else {
                    setTimeout(() => {
                      const dataParams = {
                        name: vm.$route.name,
                        params: vm.$route.params
                      }
                      if (!vm.selectedProduct) {
                        vm.$modal.show(DispositionPopup, {isPopup: true, currentPath: dataParams},{class: 'modal-localization'})
                      }
                    }, 1000)
                  }
                }
                vm.isLoadingCategory = false
              }, () => {
                vm.isLoadingCategory = false
              })
            }
          }
        },
        reSortMenu(items) {
          for (let i = 0; i < items.length; i++) {
            let _item = items[i]
            for (let s = 0; s < _item.singles.length; s++) {
              let _single = _item.singles[s]
              let attributes = []
              if (_single.menu_attributes && _single.menu_attributes.length > 0) {
                for (let j of _single.menu_attributes) {
                  attributes.push(j.uuid)
                }
              }
              items[i].singles[s] = {..._single, attributes}
            }
          }
          return items
        },
        getMinPrice(item) {
          let price = 0
          if (item.first_layers.length > 1) {
            for (let i = 0; i < item.first_layers.length; i++) {
              for (let j = 0; j < item.first_layers[i].second_layers.length; j++) {
                if (item.first_layers[i].second_layers[j].prices.length > 0) {
                  if (i == 0) {
                    price = this.formatNum(item.first_layers[i].second_layers[j].prices[0].price)
                  } else if (item.first_layers[i].second_layers[j].prices[0].price < price) {
                    price = this.formatNum(item.first_layers[i].second_layers[j].prices[0].price)
                  }
                }
              }
            }
          } else {
            price = this.formatNum(item.prices[0].price)
          }
          return price
        },
        getItemByUuid(list, uuid) {
          return list.find((el) => {
            return el.uuid === uuid
          })
        },
        redeemCode: function () {
          let vm = this
          vm.couponMessage = ''

          if (vm.couponCode) {
            vm.axios.apiCoupon.getRedeemCoupon({
              code: vm.couponCode,
             current_date: vm.getCurrentDateLocal(),
              isShowNotify: false
            }, (response) => {
              if (response.data.status) {
                vm.$notify({
                  type: 'success',
                  title: vm.$t('coupon.redeem_success')
                })

                vm.initData()
                //vm.redirectToMenuPage(vm.$const.HEADER_MENU.COUPON, null, null, true)
                //vm.redirectToUrl('/order/coupons', true)
              } else {
                vm.couponMessage = vm.$t('coupon_attach.message_error')
              }
            }, (error) => {
              vm.couponMessage = vm.getMessageFromGms(error)
            })
          } else {
            vm.couponMessage = vm.$t('coupon_attach.message_error')
          }
        },
        isComboPage: function () {
          let vm = this
          return vm.$const.SLUG_LIST.DEAL.indexOf(vm.selectedCategory.slug) >= 0
        }
      }
    }

    function getHalfDiscount(vm, column = 4, category) {
      let image = ''
      let half = {}
      let halfData = {}
      half.main_description = '';
      half.isHalf = true;
      let orderType = vm.$disposition.getByKey(vm, 'orderType', 'D').charAt(0)

      // fetch H&H list from Category API
      let storeHalfHalfs = (category.half_halfs.length > 0) ? category.half_halfs : []

      if (orderType == 'D') {
        halfData = vm.getItemByUuid(storeHalfHalfs, vm.$const.HALF_HALF_30_UUID)
        half.uuid = vm.$const.HALF_HALF_30_UUID

        image = vm.$const.HALF_HALF_IMAGES.NORMAL_4_30
      } else {
        halfData = vm.getItemByUuid(storeHalfHalfs, vm.$const.HALF_HALF_50_UUID)
        half.uuid = vm.$const.HALF_HALF_50_UUID

        image = vm.$const.HALF_HALF_IMAGES.NORMAL_4_50
      }

      half.name = halfData.name
      half.name_en = halfData.name_en
      half.price = halfData.price
      half.display_price = halfData.display_price
      half.marketing_description = halfData.marketing_description

      half.onlyLunch = vm.$const.HALF_HALF_SET.NORMAL
      half.discount = 1

      if (column == 2) {
        half.columnDisplay = column
        image = halfData.image_in_category && halfData.image_in_category.desktop_thumbnail
      }

      half.image = {
        desktop_thumbnail: image,
        mobile_thumbnail: image
      };

      return (halfData) ? half : ''
    }

    function getPick30Half(vm, displayColumn = 4, category) {
      let image = ''
      let half = {}
      let halfData = {}
      half.main_description = '';
      half.isHalf = true;

      // fetch H&H list from Category API
      let storeHalfHalfs = (category.half_halfs.length > 0) ? category.half_halfs : []

      halfData = vm.getItemByUuid(storeHalfHalfs, vm.$const.HALF_HALF_30_PICKUP_UUID)
      half.uuid = vm.$const.HALF_HALF_30_PICKUP_UUID

      if (halfData) {
        half.name = halfData.name
        half.name_en = halfData.name_en
        half.marketing_description = halfData.marketing_description
        half.price = halfData.price
        half.display_price = halfData.display_price

        half.onlyLunch = vm.$const.HALF_HALF_SET.NORMAL
        half.discount = 1
        half.is30Pick = 1
        image = vm.$const.HALF_HALF_IMAGES.NORMAL_4
        if (displayColumn == 2) {
          half.columnDisplay = 2
          image = halfData.image_in_category && halfData.image_in_category.desktop_thumbnail
        }

        half.image = {
          desktop_thumbnail: image,
          mobile_thumbnail: image
        }

        return half
      } else {
        return ''
      }
    }

  function getHalf (vm, type = 0, displayColumn = 4, category) {
    let image = ''
    let half = {}
    let halfData = {}
    half.main_description = ''
    half.isHalf = true

    // fetch H&H list from Category API
    let storeHalfHalfs = (category.half_halfs.length > 0) ? category.half_halfs : []

    // LUNCH
    if (type == 1) {
      halfData = vm.getItemByUuid(storeHalfHalfs, vm.$const.HALF_HALF_LUNCH_UUID)
      if(halfData && halfData !== undefined){
        half.uuid = vm.$const.HALF_HALF_LUNCH_UUID;
        half.onlyLunch = vm.$const.HALF_HALF_SET.LUNCH
        image = vm.$const.HALF_HALF_IMAGES.LUNCH_4
      }
    } else if (type == 0) { // NORMAL H&H
      halfData = vm.getItemByUuid(storeHalfHalfs, vm.$const.HALF_HALF_UUID)
      if(halfData && halfData !== undefined) {
        half.uuid = vm.$const.HALF_HALF_UUID;

        half.onlyLunch = vm.$const.HALF_HALF_SET.NORMAL
        image = vm.$const.HALF_HALF_IMAGES.NORMAL_4
      }
    }
    if(halfData && halfData !== undefined){
      half.name = halfData.name
      half.name_en = halfData.name_en
      half.marketing_description = halfData.marketing_description
      half.price = halfData.price
      half.display_price = halfData.display_price

      if (displayColumn == 2) {
        half.columnDisplay = 2
        image = halfData.image_in_category && halfData.image_in_category.desktop_thumbnail
      }

      half.image = {
        desktop_thumbnail: image,
        mobile_thumbnail: image
      }

      return half
    }
    return ''
  }
</script>
<style>
  #modal-menu .modal-action {
    padding: 8px !important
  }

  .fs-30 {
    font-size: 30px
  }

  .pr-7 {
    padding-right: 7px;
  }

  .pl-7 {
    padding-left: 7px
  }

  .pb-0 {
    padding-bottom: 0px !important
  }

  .mobile {
    display: none
  }

  .desktop {
    display: block
  }

  @media only screen and (max-width: 767px) {
    .mobile {
      display: block !important
    }

    .desktop {
      display: none !important
    }
  }

  .watermark img {
    width: 320px;
  }

  @media only screen and (min-width: 640px) {
    .watermark img {
      width: 400px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Category.vue